// Jwalek translations — keep keys stable and English text as fallback.
// Only high-visibility, customer-facing surfaces are translated. Untranslated
// strings gracefully fall back to English via `t(key, fallback)`.
export const LANGS = [
  { code: 'en', label: 'English', short: 'EN', dir: 'ltr' },
  { code: 'ar', label: 'العربية', short: 'ع', dir: 'rtl' },
];

const dict = {
  // --- Nav / Header ---
  'nav.shop': { en: 'Shop', ar: 'المتجر' },
  'nav.designs': { en: 'Designs', ar: 'التصاميم' },
  'nav.community': { en: 'Community', ar: 'المجتمع' },
  'nav.topRated': { en: 'Top Rated', ar: 'الأعلى تقييمًا' },
  'nav.aiGenerator': { en: 'AI Generator', ar: 'مولّد الذكاء الاصطناعي' },
  'nav.contact': { en: 'Contact', ar: 'تواصل' },
  'nav.signIn': { en: 'Sign in', ar: 'تسجيل الدخول' },
  'nav.signOut': { en: 'Sign out', ar: 'تسجيل الخروج' },
  'nav.profile': { en: 'Profile', ar: 'الملف الشخصي' },
  'nav.myDesigns': { en: 'My Designs', ar: 'تصاميمي' },
  'nav.favorites': { en: 'Favorites', ar: 'المفضلة' },
  'nav.orders': { en: 'Orders', ar: 'الطلبات' },
  'nav.notifications': { en: 'Notifications', ar: 'الإشعارات' },
  'nav.cart': { en: 'Cart', ar: 'السلة' },
  'nav.admin': { en: 'Admin Dashboard', ar: 'لوحة الإدارة' },
  'nav.theme': { en: 'Toggle theme', ar: 'تبديل السمة' },
  'nav.currency': { en: 'Switch currency', ar: 'تبديل العملة' },
  'nav.language': { en: 'Switch language', ar: 'تبديل اللغة' },
  'nav.menu': { en: 'Menu', ar: 'القائمة' },
  'nav.preferences': { en: 'Preferences', ar: 'التفضيلات' },
  'nav.browse': { en: 'Browse', ar: 'تصفّح' },
  'nav.account': { en: 'Account', ar: 'الحساب' },
  'nav.light': { en: 'Light', ar: 'فاتح' },
  'nav.dark': { en: 'Dark', ar: 'داكن' },
  'nav.terms': { en: 'Terms', ar: 'الشروط' },
  'nav.privacy': { en: 'Privacy', ar: 'الخصوصية' },
  'nav.home': { en: 'Home', ar: 'الرئيسية' },

  // --- NotFound (404 page) ---
  'notFound.tag': { en: 'Off the map', ar: 'خارج الخريطة' },
  'notFound.title': { en: "This page took a detour — let's get you back.", ar: 'هذه الصفحة سلكت طريقًا مختلفًا — دعنا نُعيدك.' },
  'notFound.sub': { en: 'Search our design library, phone cases, stickers and labels — or jump into what everyone else is loving right now.', ar: 'ابحث في مكتبة التصاميم وأغطية الجوّال والملصقات واللاصقات — أو انتقل إلى ما يحبّه الجميع الآن.' },
  'notFound.placeholder': { en: 'Search designs, phone models, categories...', ar: 'ابحث عن تصاميم أو موديلات جوّال أو فئات...' },
  'notFound.resultsFor': { en: 'Results for "{q}"', ar: 'نتائج البحث عن "{q}"' },
  'notFound.popular': { en: 'Popular destinations', ar: 'الوجهات الأكثر زيارة' },

  // --- Landing / Hero ---
  'landing.tagline': { en: 'Design it your way — we print it perfectly.', ar: 'صمّم بأسلوبك — ونحن نطبعه بإتقان.' },
  'landing.startDesigning': { en: 'Start Designing', ar: 'ابدأ التصميم' },
  'landing.browseShop': { en: 'Browse Shop', ar: 'تصفّح المتجر' },
  'landing.browseDesigns': { en: 'Browse Designs', ar: 'تصفّح التصاميم' },
  'landing.aiGenerateCta': { en: 'Generate with AI', ar: 'أنشئ بالذكاء الاصطناعي' },
  'landing.trending': { en: 'Trending Designs', ar: 'تصاميم رائجة' },
  'landing.categories': { en: 'Shop by category', ar: 'تسوّق حسب الفئة' },
  'landing.aiBadge': { en: '✨ Now with AI Design Generator', ar: '✨ متوفّر الآن مولّد التصميم بالذكاء الاصطناعي' },
  'landing.rating': { en: '· 10,000+ happy customers', ar: '· أكثر من ١٠٬٠٠٠ عميل سعيد' },
  'landing.printAnything': { en: 'Print anything.', ar: 'اطبع أي شيء.' },
  'landing.printAnythingSub': { en: 'Three product lines, unlimited possibilities.', ar: 'ثلاث فئات من المنتجات، إمكانيات لا حدود لها.' },
  'landing.explore': { en: 'Explore', ar: 'استكشف' },
  'landing.from': { en: 'From', ar: 'ابتداءً من' },
  'landing.whyTitle': { en: 'Why', ar: 'لماذا' },
  'landing.whyQuestion': { en: '?', ar: '؟' },
  'landing.whySub': { en: 'Premium quality, seamless creation, and delightful delivery — every time.', ar: 'جودة عالية، تصميم سلس، وتوصيل مُبهج — في كل مرة.' },
  'landing.everythingTitle': { en: 'Everything you need to create & sell.', ar: 'كل ما تحتاجه للتصميم والبيع.' },
  'landing.everythingSub': { en: 'A powerful design editor, a rich library of templates, and thoughtful features that make custom printing effortless.', ar: 'محرر تصميم قوي، مكتبة قوالب غنية، ومزايا مدروسة تجعل الطباعة المخصصة سهلة.' },
  'landing.earnTitle': { en: 'Earn & save with Jwalek.', ar: 'اربح ووفّر مع جواليك.' },
  'landing.ctaTitle': { en: 'Bring your ideas to life.', ar: 'حوّل أفكارك إلى واقع.' },
  'landing.ctaSub': { en: 'Design now, print perfectly. Get started in seconds.', ar: 'صمّم الآن واطبع بإتقان. ابدأ خلال ثوانٍ.' },
  'landing.getStarted': { en: 'Get Started', ar: 'ابدأ الآن' },
  'landing.seeAll': { en: 'See all', ar: 'عرض الكل' },

  // Product tiles on Landing (kept simple — using existing productType/shop keys)
  'landing.phoneCasesTitle': { en: 'Phone Cases', ar: 'أغطية الجوال' },
  'landing.phoneCasesDesc': { en: 'Premium quality cases with edge-to-edge print protection.', ar: 'أغطية جوال عالية الجودة بطباعة تغطي الأطراف بالكامل.' },
  'landing.stickersTitle': { en: 'Stickers', ar: 'ملصقات' },
  'landing.stickersDesc': { en: 'Waterproof vinyl stickers in every shape and finish.', ar: 'ملصقات فينيل مقاومة للماء بأشكال ولمسات متعدّدة.' },
  'landing.labelsTitle': { en: 'Labels', ar: 'اللاصقات' },
  'landing.labelsDesc': { en: 'Vibrant product labels for packaging and branding.', ar: 'لاصقات منتجات نابضة بالألوان للتغليف والعلامة التجارية.' },

  // Why cards
  'landing.whyEasyTitle': { en: 'Easy to Design', ar: 'سهل التصميم' },
  'landing.whyEasyDesc': { en: 'Powerful, intuitive tools for everyone — no design skills required.', ar: 'أدوات قوية وسهلة الاستخدام — بدون خبرة سابقة في التصميم.' },
  'landing.whyQualityTitle': { en: 'High Quality Print', ar: 'طباعة عالية الجودة' },
  'landing.whyQualityDesc': { en: 'Advanced print technology with vibrant, long-lasting colors.', ar: 'تقنية طباعة متطوّرة بألوان زاهية تدوم طويلًا.' },
  'landing.whyFastTitle': { en: 'Fast Delivery', ar: 'توصيل سريع' },
  'landing.whyFastDesc': { en: 'Quick production and reliable delivery to your doorstep.', ar: 'إنتاج سريع وتوصيل موثوق إلى باب منزلك.' },
  'landing.whySecureTitle': { en: 'Secure & Safe', ar: 'آمن وموثوق' },
  'landing.whySecureDesc': { en: '256-bit SSL secured payments — your data stays protected.', ar: 'مدفوعات مؤمّنة بتشفير SSL 256-بت — بياناتك بأمان.' },

  // App feature cards
  'landing.featLibraryTitle': { en: 'Massive Design Library', ar: 'مكتبة تصاميم ضخمة' },
  'landing.featLibraryDesc': { en: 'Thousands of unique designs across every style.', ar: 'آلاف التصاميم الفريدة بأساليب متنوّعة.' },
  'landing.featAiTitle': { en: 'AI Design Generator', ar: 'مولّد التصميم بالذكاء الاصطناعي' },
  'landing.featAiDesc': { en: 'Describe your idea — our AI creates it for you.', ar: 'اوصف فكرتك — والذكاء الاصطناعي ينشئها لك.' },
  'landing.featSaveTitle': { en: 'Save Your Designs', ar: 'احفظ تصاميمك' },
  'landing.featSaveDesc': { en: 'Save, edit and re-use your designs anytime.', ar: 'احفظ وعدّل واستخدم تصاميمك في أي وقت.' },
  'landing.featGiftTitle': { en: 'Gift & Share', ar: 'أهدِ وشارك' },
  'landing.featGiftDesc': { en: 'Send custom gifts or share your designs.', ar: 'أرسل هدايا مخصصة أو شارك تصاميمك.' },
  'landing.featLoyaltyTitle': { en: 'Loyalty Rewards', ar: 'مكافآت الولاء' },
  'landing.featLoyaltyDesc': { en: 'Earn points on every order and redeem exclusive rewards.', ar: 'اكسب نقاطًا على كل طلب واستبدلها بمكافآت حصرية.' },
  'landing.featTrackTitle': { en: 'Order Tracking', ar: 'تتبّع الطلبات' },
  'landing.featTrackDesc': { en: 'Track your order in real-time from production to delivery.', ar: 'تتبّع طلبك لحظة بلحظة من الإنتاج حتى التسليم.' },
  'landing.featReorderTitle': { en: 'Easy Reorder', ar: 'إعادة طلب سريعة' },
  'landing.featReorderDesc': { en: 'Reorder your previous products with one tap.', ar: 'أعد طلب منتجاتك السابقة بضغطة واحدة.' },
  'landing.featSupportTitle': { en: 'Excellent Support', ar: 'دعم مميّز' },
  'landing.featSupportDesc': { en: 'Friendly team available 24/7.', ar: 'فريق ودود متاح على مدار الساعة.' },

  // Earn section
  'landing.earnSellTitle': { en: 'Sell Your Designs', ar: 'بِع تصاميمك' },
  'landing.earnSellDesc': { en: 'Become a designer and earn from every sale.', ar: 'كن مصمّمًا واربح من كل عملية بيع.' },
  'landing.earnPremiumTitle': { en: 'Jwalek Premium', ar: 'جواليك بريميوم' },
  'landing.earnPremiumDesc': { en: 'Monthly / yearly membership with exclusive perks.', ar: 'اشتراك شهري أو سنوي بمزايا حصرية.' },
  'landing.earnCorpTitle': { en: 'Corporate & Bulk', ar: 'للشركات والطلبات بالجملة' },
  'landing.earnCorpDesc': { en: 'Special pricing for businesses and organizations.', ar: 'أسعار خاصة للشركات والمؤسسات.' },

  // Trust badges
  'landing.trustQuality': { en: 'Quality Guarantee', ar: 'ضمان الجودة' },
  'landing.trustReturns': { en: 'Easy Returns', ar: 'إرجاع سهل' },
  'landing.trustPayments': { en: 'Secure Payments', ar: 'مدفوعات آمنة' },
  'landing.trustLocal': { en: 'Local Production', ar: 'إنتاج محلّي' },
  'landing.trustEco': { en: 'Eco Friendly', ar: 'صديق للبيئة' },

  // --- Shop page type descriptions ---
  'shop.desc.all': { en: 'Browse premium custom-printed phone cases, stickers, and labels. Design your own or pick from thousands of templates.', ar: 'تصفّح أغطية الجوّال والملصقات واللاصقات المخصصة عالية الجودة. صمّم بنفسك أو اختر من آلاف القوالب.' },
  'shop.desc.phone_case': { en: 'Premium quality custom iPhone cases with edge-to-edge print. Choose from clear, matte, and frosted finishes.', ar: 'أغطية آيفون مخصصة بجودة عالية وطباعة تغطي الأطراف. اختر بين اللمسة الشفافة والمطفية والمثلّجة.' },
  'shop.desc.sticker': { en: 'Waterproof vinyl stickers in every shape and size. Glossy, matte, holographic finishes for laptops, bottles, and more.', ar: 'ملصقات فينيل مقاومة للماء بأشكال ومقاسات متعدّدة. لمسات لامعة ومطفية وهولوغرام للحاسوب والزجاجات وغيرها.' },
  'shop.desc.label': { en: 'Vibrant custom labels for packaging, jars, bottles and branding. Glossy, kraft, and clear finishes available.', ar: 'لاصقات نابضة بالألوان للتغليف والمرطبانات والزجاجات والعلامة التجارية. لمسات لامعة وكرافت وشفّافة.' },

  // --- Profile loyalty explainer ---
  'profile.premiumTiers': { en: 'Premium plans', ar: 'خطط بريميوم' },
  'profile.perMonth': { en: '/ mo', ar: '/ شهريًا' },
  'profile.howItWorks': { en: 'How loyalty works', ar: 'كيف تعمل نقاط الولاء' },
  'profile.rulesEarn': { en: 'Earn {pts} pt per {amt} spent.', ar: 'اكسب {pts} نقطة عن كل {amt} تنفقه.' },
  'profile.rulesRedeem': { en: 'Redeem 100 pts for {off} off (min order {min}).', ar: 'استبدل 100 نقطة بخصم {off} (الحدّ الأدنى للطلب {min}).' },
  'profile.rulesExpiry': { en: 'Points expire after {n} days.', ar: 'تنتهي صلاحية النقاط بعد {n} يومًا.' },

  // --- Premium subscribe flow ---
  'subscribe.title': { en: 'Start Jwalek Premium — {tier}', ar: 'انضم إلى جواليك بريميوم — {tier}' },
  'subscribe.subtitle': { en: "We'll generate an invoice for you to pay. Once payment is received, your premium perks activate automatically.", ar: 'سننشئ لك فاتورة للسداد. بمجرد استلام الدفعة، تُفعَّل مزاياك الحصرية تلقائيًا.' },
  'subscribe.billing': { en: 'Billing', ar: 'الفوترة' },
  'subscribe.monthly': { en: 'Monthly', ar: 'شهري' },
  'subscribe.annual': { en: 'Annual', ar: 'سنوي' },
  'subscribe.month': { en: 'month', ar: 'شهر' },
  'subscribe.year': { en: 'year', ar: 'سنة' },
  'subscribe.paymentNote': { en: "You won't be charged online. We'll send the invoice, confirm the payment, and activate your tier once it clears.", ar: 'لن يتم خصم أي مبلغ إلكترونيًا. سنرسل لك الفاتورة ونؤكّد الدفع ثم نُفعّل خطتك فور الاستلام.' },
  'subscribe.total': { en: 'Total', ar: 'الإجمالي' },
  'subscribe.confirm': { en: 'Get invoice', ar: 'أنشئ الفاتورة' },
  'subscribe.placing': { en: 'Placing...', ar: 'جارٍ الإرسال...' },
  'subscribe.pleaseFill': { en: 'Please fill in {field}', ar: 'يرجى تعبئة {field}' },
  'subscribe.placedToast': { en: 'Subscription request placed — opening your invoice.', ar: 'تم إرسال طلب الاشتراك — سنفتح فاتورتك.' },
  'subscribe.failed': { en: 'Could not place subscription', ar: 'تعذّر إرسال الاشتراك' },
  'subscribe.startTier': { en: 'Start {tier}', ar: 'ابدأ خطة {tier}' },
  'subscribe.currentPlan': { en: 'Current plan', ar: 'خطتك الحالية' },
  'subscribe.alreadyActive': { en: 'Already active', ar: 'مُفعّل بالفعل' },
  'subscribe.invoicePending': { en: 'Invoice pending', ar: 'الفاتورة قيد السداد' },
  'subscribe.awaitingTitle': { en: 'Awaiting payment — {tier}', ar: 'بانتظار الدفع — {tier}' },
  'subscribe.awaitingSub': { en: 'Invoice {no} · once payment clears your perks activate automatically.', ar: 'الفاتورة {no} · فور تأكيد الدفع تُفعَّل المزايا تلقائيًا.' },
  'subscribe.viewInvoice': { en: 'View invoice', ar: 'عرض الفاتورة' },
  'subscribe.openOrder': { en: 'Open order', ar: 'فتح الطلب' },

  // --- Shop ---
  'shop.all': { en: 'All', ar: 'الكل' },
  'shop.phoneCases': { en: 'Phone Cases', ar: 'أغطية الجوال' },
  'shop.stickers': { en: 'Stickers', ar: 'ملصقات' },
  'shop.labels': { en: 'Labels', ar: 'اللاصقات' },
  'shop.title': { en: 'Shop Custom Prints', ar: 'المطبوعات المخصصة' },
  'shop.subtitle': { en: 'Pick a product and start designing.', ar: 'اختر منتجًا وابدأ التصميم.' },
  'shop.search': { en: 'Search products', ar: 'ابحث عن منتج' },
  'shop.noneFound': { en: 'No products found.', ar: 'لا توجد منتجات.' },

  // --- Product ---
  'product.finish': { en: 'Finish', ar: 'اللمسة النهائية' },
  'product.model': { en: 'Model', ar: 'الطراز' },
  'product.iphoneModel': { en: 'iPhone model', ar: 'طراز آيفون' },
  'product.size': { en: 'Size', ar: 'المقاس' },
  'product.shapeSize': { en: 'Shape / size', ar: 'الشكل / المقاس' },
  'product.startDesigning': { en: 'Start Designing', ar: 'ابدأ التصميم' },
  'product.addBlank': { en: 'Add blank to cart', ar: 'أضف فارغًا إلى السلة' },
  'product.addToCart': { en: 'Add to cart', ar: 'أضف إلى السلة' },
  'product.freeShipOver': { en: 'Free shipping over', ar: 'شحن مجاني فوق' },
  'product.quantity': { en: 'Quantity', ar: 'الكمية' },
  'product.total': { en: 'Total', ar: 'الإجمالي' },
  'product.customize': { en: 'Customize in editor', ar: 'خصّص في المحرر' },
  'product.qualityGuarantee': { en: 'Quality Guarantee', ar: 'ضمان الجودة' },
  'product.fastDelivery': { en: 'Fast Delivery', ar: 'توصيل سريع' },
  'product.ecoFriendly': { en: 'Eco Friendly', ar: 'صديق للبيئة' },

  // --- Cart / Checkout ---
  'cart.title': { en: 'Your Cart', ar: 'سلة المشتريات' },
  'cart.empty': { en: 'Your cart is empty', ar: 'سلة المشتريات فارغة' },
  'cart.continueShopping': { en: 'Start designing to add products to your cart.', ar: 'ابدأ بالتصميم لإضافة منتجات إلى سلتك.' },
  'cart.checkout': { en: 'Checkout', ar: 'إتمام الشراء' },
  'cart.subtotal': { en: 'Subtotal', ar: 'المجموع الفرعي' },
  'cart.shipping': { en: 'Shipping', ar: 'الشحن' },
  'cart.total': { en: 'Total', ar: 'الإجمالي' },
  'cart.orderSummary': { en: 'Order Summary', ar: 'ملخّص الطلب' },
  'cart.bulkDiscount': { en: 'Bulk discount', ar: 'خصم الكمية' },
  'cart.free': { en: 'Free', ar: 'مجاني' },
  'cart.addMore': { en: 'Add {n} more items to unlock 5% bulk discount.', ar: 'أضف {n} منتجات لفتح خصم الكمية 5%.' },
  'cart.itemUpdated': { en: 'Cart updated', ar: 'تم تحديث السلة' },
  'cart.itemRemoved': { en: 'Item removed', ar: 'تم حذف المنتج' },
  'cart.bulkTitle5': { en: 'Bulk 5%', ar: 'خصم 5%' },
  'cart.bulkTitle10': { en: 'Bulk 10%', ar: 'خصم 10%' },
  'cart.bulkTitle15': { en: 'Bulk 15%', ar: 'خصم 15%' },
  'checkout.title': { en: 'Checkout', ar: 'إتمام الشراء' },
  'checkout.subtitle': { en: 'Confirm your delivery details — no payment required now, we contact you to arrange delivery and settlement.', ar: 'أكّد بيانات التوصيل — لا يلزم الدفع الآن، سنتواصل معك لترتيب التوصيل والدفع.' },
  'checkout.shippingAddress': { en: 'Shipping Address', ar: 'عنوان الشحن' },
  'checkout.fullName': { en: 'Full name', ar: 'الاسم الكامل' },
  'checkout.addressLine': { en: 'Address line', ar: 'العنوان' },
  'checkout.city': { en: 'City', ar: 'المدينة' },
  'checkout.state': { en: 'State / Region', ar: 'المنطقة' },
  'checkout.zip': { en: 'Postal code', ar: 'الرمز البريدي' },
  'checkout.country': { en: 'Country', ar: 'الدولة' },
  'checkout.selectCountry': { en: 'Select country', ar: 'اختر الدولة' },
  'checkout.phone': { en: 'Phone (optional)', ar: 'الهاتف (اختياري)' },
  'checkout.paymentOnDelivery': { en: 'Payment on delivery', ar: 'الدفع عند التسليم' },
  'checkout.paymentNote': { en: 'No online payment is required at this stage. After placing your order, our team will contact you to confirm the design, delivery address, and settle the amount on delivery.', ar: 'لا يلزم الدفع الإلكتروني الآن. بعد تقديم الطلب سيتواصل فريقنا معك لتأكيد التصميم وعنوان التوصيل واستلام المبلغ عند التسليم.' },
  'checkout.sslNote': { en: 'Your data is protected with 256-bit SSL. We\'ll only use it to fulfill your order.', ar: 'بياناتك محميّة بتشفير SSL 256-بت ولن تُستخدم إلا لإتمام طلبك.' },
  'checkout.placeOrder': { en: 'Place order', ar: 'تأكيد الطلب' },
  'checkout.placing': { en: 'Placing order...', ar: 'جارٍ تقديم الطلب...' },
  'checkout.summary': { en: 'Summary', ar: 'الملخّص' },
  'checkout.items': { en: 'items', ar: 'منتجات' },
  'checkout.orderPlacedToast': { en: 'Order placed! Your confirmation PDF is ready. We will invoice once your order enters production.', ar: 'تم تقديم الطلب! جاهزة نسخة تأكيد الطلب بصيغة PDF. سنُصدر الفاتورة عند دخول الطلب مرحلة الإنتاج.' },
  'checkout.failed': { en: 'Checkout failed', ar: 'فشل إتمام الشراء' },

  // --- Orders ---
  'orders.title': { en: 'Your Orders', ar: 'طلباتك' },
  'orders.empty': { en: 'No orders yet', ar: 'لا توجد طلبات بعد' },
  'orders.emptyDesc': { en: 'Once you place an order, it will appear here.', ar: 'بعد تقديم طلبك سيظهر هنا.' },
  'orders.startShopping': { en: 'Start shopping', ar: 'ابدأ التسوّق' },
  'orders.placed': { en: 'Placed', ar: 'تم الطلب' },
  'orders.inProduction': { en: 'In Production', ar: 'قيد الإنتاج' },
  'orders.shipped': { en: 'Shipped', ar: 'تم الشحن' },
  'orders.delivered': { en: 'Delivered', ar: 'تم التسليم' },
  'orders.cancelled': { en: 'Cancelled', ar: 'ملغى' },
  'orders.placedOn': { en: 'Placed', ar: 'بتاريخ' },
  'orders.track': { en: 'Track order', ar: 'تتبّع الطلب' },
  'orders.invoice': { en: 'Invoice (SAR)', ar: 'الفاتورة (ريال)' },
  'orders.reorder': { en: 'Reorder', ar: 'أعد الطلب' },
  'orders.reorderToast': { en: 'Added {n} items to cart', ar: 'أُضيفت {n} منتجات إلى السلة' },
  'orders.reorderFailed': { en: 'Reorder failed', ar: 'فشل إعادة الطلب' },
  'orders.history': { en: 'History', ar: 'السجل' },
  'orders.items': { en: 'Items', ar: 'المنتجات' },
  'orders.qty': { en: 'Qty', ar: 'الكمية' },
  'orders.discount': { en: 'Discount', ar: 'خصم' },
  'orders.shippingTo': { en: 'Shipping to', ar: 'الشحن إلى' },
  'orders.loading': { en: 'Loading order...', ar: 'جارٍ تحميل الطلب...' },

  // --- Profile ---
  'profile.loyaltyPoints': { en: 'Loyalty Points', ar: 'نقاط الولاء' },
  'profile.loyaltyEarn': { en: 'Earn 1 point per SAR spent', ar: 'اكسب نقطة عن كل ريال تنفقه' },
  'profile.savedDesigns': { en: 'Saved Designs', ar: 'التصاميم المحفوظة' },
  'profile.premium': { en: 'Jwalek Premium', ar: 'جواليك بريميوم' },
  'profile.premiumDesc': { en: 'Exclusive designs, free shipping, priority support.', ar: 'تصاميم حصرية، شحن مجاني، دعم أولوية.' },
  'profile.active': { en: 'Active', ar: 'مُفعّل' },
  'profile.notActive': { en: 'Not active', ar: 'غير مفعّل' },

  // --- Notifications ---
  'notifications.title': { en: 'Notifications', ar: 'الإشعارات' },
  'notifications.subtitle': { en: 'Updates about your orders and account.', ar: 'تحديثات عن طلباتك وحسابك.' },
  'notifications.markAll': { en: 'Mark all read', ar: 'اجعل الكل مقروءًا' },
  'notifications.markRead': { en: 'Mark read', ar: 'اجعله مقروءًا' },
  'notifications.empty': { en: "You're all caught up.", ar: 'لا يوجد جديد.' },

  // --- Favorites ---
  'favorites.title': { en: 'Favorites', ar: 'المفضلة' },
  'favorites.subtitle': { en: 'Designs you love, always within reach.', ar: 'التصاميم التي تحبّها في متناول يديك.' },
  'favorites.empty': { en: 'No favorites yet. Browse the design library and tap the heart icon.', ar: 'لا توجد مفضلات بعد. تصفّح مكتبة التصاميم واضغط على القلب.' },

  // --- MyDesigns ---
  'mydesigns.title': { en: 'My Designs', ar: 'تصاميمي' },
  'mydesigns.subtitle': { en: 'Reuse, add to cart, or publish your designs to the community — admin will review before going live.', ar: 'أعد الاستخدام أو أضف إلى السلة أو انشر تصاميمك في المجتمع — سيراجعها الفريق قبل النشر.' },
  'mydesigns.browseCommunity': { en: 'Browse community', ar: 'تصفّح المجتمع' },
  'mydesigns.empty': { en: 'No saved designs yet.', ar: 'لا توجد تصاميم محفوظة بعد.' },
  'mydesigns.startDesigning': { en: 'Start designing', ar: 'ابدأ التصميم' },
  'mydesigns.statusDraft': { en: 'Draft', ar: 'مسودّة' },
  'mydesigns.statusPending': { en: 'Pending review', ar: 'قيد المراجعة' },
  'mydesigns.statusApproved': { en: 'Live in community', ar: 'منشور في المجتمع' },
  'mydesigns.statusRejected': { en: 'Needs changes', ar: 'يحتاج تعديلات' },
  'mydesigns.publish': { en: 'Publish', ar: 'انشر' },
  'mydesigns.resubmit': { en: 'Resubmit', ar: 'أعد الإرسال' },
  'mydesigns.cancelSubmission': { en: 'Cancel submission', ar: 'إلغاء الإرسال' },
  'mydesigns.takeOffline': { en: 'Take offline', ar: 'إخفاء' },
  'mydesigns.viewListing': { en: 'View listing', ar: 'اعرض المنشور' },
  'mydesigns.publishTitle': { en: 'Publish to community', ar: 'نشر في المجتمع' },
  'mydesigns.publishNote': { en: 'Once submitted, an admin will review your listing. Approved listings appear in the community feed and can be liked, saved and rated by others.', ar: 'بعد الإرسال سيراجع فريقنا المنشور. المنشورات المعتمدة تظهر في المجتمع ويمكن للآخرين الإعجاب بها وتقييمها.' },
  'mydesigns.formTitle': { en: 'Title', ar: 'العنوان' },
  'mydesigns.formDescription': { en: 'Description', ar: 'الوصف' },
  'mydesigns.formTags': { en: 'Tags (comma separated)', ar: 'الوسوم (يفصل بينها فاصلة)' },
  'mydesigns.formCategory': { en: 'Category', ar: 'الفئة' },
  'mydesigns.formSubmit': { en: 'Submit for review', ar: 'أرسل للمراجعة' },
  'mydesigns.submittedToast': { en: 'Submitted for review', ar: 'أُرسل للمراجعة' },
  'mydesigns.deletedToast': { en: 'Deleted', ar: 'تم الحذف' },
  'mydesigns.hiddenToast': { en: 'Listing hidden from community', ar: 'تم إخفاء المنشور من المجتمع' },

  // --- Community ---
  'community.title': { en: 'Community Designs', ar: 'تصاميم المجتمع' },
  'community.subtitle': { en: 'Designs made by real creators, reviewed and published by our team.', ar: 'تصاميم من مصمّمين حقيقيّين، يراجعها وينشرها فريقنا.' },
  'community.search': { en: 'Search community', ar: 'ابحث في المجتمع' },
  'community.loading': { en: 'Loading community designs…', ar: 'جارٍ تحميل تصاميم المجتمع…' },
  'community.empty': { en: 'No community listings yet — be the first! Create a design and hit Publish from My Designs.', ar: 'لا توجد منشورات بعد — كن أول من ينشر! أنشئ تصميمًا واضغط نشر من "تصاميمي".' },
  'community.goToMyDesigns': { en: 'Go to My Designs', ar: 'اذهب إلى تصاميمي' },
  'community.approved': { en: 'Approved', ar: 'معتمد' },
  'community.by': { en: 'By', ar: 'بواسطة' },
  'community.anonymous': { en: 'Anonymous', ar: 'مجهول' },
  'community.notAvailable': { en: "This listing isn't available.", ar: 'هذا المنشور غير متوفر.' },
  'community.back': { en: 'Back to community', ar: 'العودة للمجتمع' },

  // --- TopRated ---
  'toprated.title': { en: 'Top Rated', ar: 'الأعلى تقييمًا' },
  'toprated.subtitle': { en: "The community's favourite products and designs — ranked by real ratings.", ar: 'أفضل المنتجات والتصاميم لدى المجتمع — مرتّبة حسب التقييمات الحقيقية.' },
  'toprated.avgRating': { en: 'Average rating', ar: 'متوسط التقييم' },
  'toprated.rankedItems': { en: 'Ranked items', ar: 'العناصر المرتّبة' },
  'toprated.totalRatings': { en: 'Total ratings', ar: 'إجمالي التقييمات' },
  'toprated.typeAll': { en: 'All', ar: 'الكل' },
  'toprated.typeProducts': { en: 'Products', ar: 'المنتجات' },
  'toprated.typeDesigns': { en: 'Designs', ar: 'التصاميم' },
  'toprated.allCategories': { en: 'All Categories', ar: 'جميع الفئات' },
  'toprated.empty': { en: 'No ratings yet in this view. Be the first to rate a product or design!', ar: 'لا توجد تقييمات بعد. كن أول من يقيّم منتجًا أو تصميمًا!' },
  'toprated.badgeProduct': { en: 'Product', ar: 'منتج' },
  'toprated.badgeDesign': { en: 'Design', ar: 'تصميم' },

  // --- DesignsLibrary ---
  'designs.title': { en: 'Design Library', ar: 'مكتبة التصاميم' },
  'designs.subtitle': { en: 'Thousands of ready-to-print designs. Pick one and customize.', ar: 'آلاف التصاميم الجاهزة للطباعة. اختر واحدًا وخصّصه.' },
  'designs.search': { en: 'Search designs', ar: 'ابحث في التصاميم' },
  'designs.empty': { en: 'No designs found. (The library is being generated by AI in the background — refresh in a moment.)', ar: 'لا توجد تصاميم. (تُنشأ المكتبة بالذكاء الاصطناعي — حدّث الصفحة بعد قليل.)' },
  'designs.useInEditor': { en: 'Use in editor', ar: 'استخدم في المحرر' },
  'designs.premium': { en: 'PREMIUM', ar: 'بريميوم' },

  // --- DesignDetail ---
  'designDetail.notFound': { en: 'Design not found', ar: 'التصميم غير موجود' },
  'designDetail.notFoundDesc': { en: 'This design may have been removed. Try browsing the full library.', ar: 'ربما أُزيل هذا التصميم. جرّب تصفّح المكتبة الكاملة.' },
  'designDetail.backLibrary': { en: 'Back to Design Library', ar: 'العودة إلى المكتبة' },
  'designDetail.productLabel': { en: 'Product', ar: 'المنتج' },
  'designDetail.stickerSheet': { en: 'Sticker sheet', ar: 'ورقة ملصقات' },
  'designDetail.labelSheet': { en: 'Label sheet', ar: 'ورقة لاصقات' },
  'designDetail.customize': { en: 'Customize in editor', ar: 'خصّص في المحرر' },
  'designDetail.browseProducts': { en: 'Browse products', ar: 'تصفّح المنتجات' },
  'designDetail.tip': { en: 'Tip: pick "Customize in editor" if you want to tweak the design before ordering.', ar: 'نصيحة: اختر "خصّص في المحرر" إذا أردت تعديل التصميم قبل الطلب.' },
  'designDetail.more': { en: 'More {cat} designs', ar: 'المزيد من تصاميم {cat}' },
  'designDetail.signInAddCart': { en: 'Sign in to add items to your cart', ar: 'سجّل دخولك لإضافة منتجات إلى السلة' },
  'designDetail.signInToAddButton': { en: 'Sign in to add to cart', ar: 'سجّل الدخول للإضافة إلى السلة' },
  'designDetail.adding': { en: 'Adding...', ar: 'جارٍ الإضافة...' },
  'designDetail.addedToast': { en: 'Added to cart', ar: 'أُضيف إلى السلة' },
  'designDetail.viewCart': { en: 'View cart', ar: 'اعرض السلة' },
  'designDetail.noCompatibleProduct': { en: 'This design has no compatible product yet.', ar: 'لا يوجد منتج متوافق مع هذا التصميم بعد.' },
  'designDetail.couldNotAdd': { en: 'Could not add to cart', ar: 'تعذّرت الإضافة إلى السلة' },

  // --- AI Generator ---
  'ai.title': { en: 'AI Design Generator', ar: 'مولّد التصميم بالذكاء الاصطناعي' },
  'ai.subtitle': { en: 'Describe what you want to print. Our AI generates unique artwork you can drop straight into the editor.', ar: 'صف ما تريد طباعته وسينشئ الذكاء الاصطناعي عملًا فنيًا فريدًا يمكنك استخدامه في المحرر مباشرة.' },
  'ai.prompt': { en: 'Prompt', ar: 'الوصف' },
  'ai.promptPlaceholder': { en: 'e.g. A cute cartoon avocado with sunglasses, sticker style', ar: 'مثال: أفوكادو كرتوني ظريف يرتدي نظّارات، بأسلوب ملصق' },
  'ai.category': { en: 'Category', ar: 'الفئة' },
  'ai.style': { en: 'Style (optional)', ar: 'الأسلوب (اختياري)' },
  'ai.generate': { en: 'Generate', ar: 'أنشئ' },
  'ai.generating': { en: 'Generating...', ar: 'جارٍ الإنشاء...' },
  'ai.creating': { en: 'Creating your masterpiece...', ar: 'ننشئ تحفتك...' },
  'ai.emptyResults': { en: 'Your generated designs will appear here.', ar: 'ستظهر تصاميمك المُولّدة هنا.' },
  'ai.policyNote': { en: 'Please respect IP and content policy. Generated images are unique to your prompt.', ar: 'يرجى احترام حقوق الملكية وسياسة المحتوى. الصور المُولّدة فريدة لطلبك.' },
  'ai.enterPrompt': { en: 'Enter a prompt', ar: 'أدخل وصفًا' },
  'ai.generated': { en: 'Design generated!', ar: 'تم إنشاء التصميم!' },
  'ai.failed': { en: 'Generation failed', ar: 'فشل الإنشاء' },
  'ai.catSticker': { en: 'Sticker', ar: 'ملصق' },
  'ai.catPhoneCase': { en: 'Phone Case', ar: 'غطاء جوّال' },
  'ai.catLabel': { en: 'Label', ar: 'لاصقة' },

  // --- Contact ---
  'contact.title': { en: 'Get in touch', ar: 'تواصل معنا' },
  'contact.subtitle': { en: 'Questions, feedback or bulk-order inquiries — we\'d love to hear from you.', ar: 'أسئلة أو ملاحظات أو طلبات بالجملة — يسعدنا سماعك.' },
  'contact.name': { en: 'Name', ar: 'الاسم' },
  'contact.email': { en: 'Email', ar: 'البريد الإلكتروني' },
  'contact.subject': { en: 'Subject', ar: 'الموضوع' },
  'contact.message': { en: 'Message', ar: 'الرسالة' },
  'contact.human': { en: "To prove you're human: what is", ar: 'لإثبات أنّك إنسان: ما ناتج' },
  'contact.send': { en: 'Send message', ar: 'أرسل الرسالة' },
  'contact.sending': { en: 'Sending...', ar: 'جارٍ الإرسال...' },
  'contact.thanks': { en: 'Thanks for reaching out!', ar: 'شكرًا لتواصلك!' },
  'contact.thanksDesc': { en: 'We received your message and will get back to you soon.', ar: 'استلمنا رسالتك وسنردّ عليك قريبًا.' },
  'contact.sendAnother': { en: 'Send another', ar: 'أرسل رسالة أخرى' },
  'contact.fillAll': { en: 'Please fill in all fields', ar: 'يرجى تعبئة جميع الحقول' },
  'contact.sentToast': { en: "Message sent — we'll reply soon", ar: 'أُرسلت الرسالة — سنردّ قريبًا' },
  'contact.sendFailed': { en: 'Failed to send', ar: 'فشل الإرسال' },

  // --- Login / Register ---
  'login.welcomeBack': { en: 'Welcome back', ar: 'أهلًا بعودتك' },
  'login.signInJwalek': { en: 'Sign in to your Jwalek account', ar: 'سجّل الدخول إلى حسابك في جواليك' },
  'login.orWithEmail': { en: 'or with email', ar: 'أو بالبريد الإلكتروني' },
  'login.password': { en: 'Password', ar: 'كلمة المرور' },
  'login.signingIn': { en: 'Signing in...', ar: 'جارٍ تسجيل الدخول...' },
  'login.noAccount': { en: 'No account?', ar: 'لا تملك حسابًا؟' },
  'login.createOne': { en: 'Create one', ar: 'أنشئ حسابًا' },
  'login.welcomeToast': { en: 'Welcome back!', ar: 'أهلًا بعودتك!' },
  'login.failed': { en: 'Login failed', ar: 'فشل تسجيل الدخول' },
  'register.createAccount': { en: 'Create your account', ar: 'أنشئ حسابك' },
  'register.startInSeconds': { en: 'Start designing in seconds', ar: 'ابدأ التصميم في ثوانٍ' },
  'register.creating': { en: 'Creating account...', ar: 'جارٍ إنشاء الحساب...' },
  'register.submit': { en: 'Create account', ar: 'أنشئ حسابًا' },
  'register.haveAccount': { en: 'Already have an account?', ar: 'لديك حساب بالفعل؟' },
  'register.welcomeToast': { en: 'Welcome to Jwalek!', ar: 'مرحبًا بك في جواليك!' },
  'register.failed': { en: 'Registration failed', ar: 'فشل إنشاء الحساب' },

  // --- SignedInHome ---
  'signed.greetingMorning': { en: 'Good morning, ', ar: 'صباح الخير، ' },
  'signed.greetingAfternoon': { en: 'Good afternoon, ', ar: 'مساء الخير، ' },
  'signed.greetingEvening': { en: 'Good evening, ', ar: 'مساء الخير، ' },
  'signed.greetingNight': { en: 'Hey there, ', ar: 'مرحبًا، ' },
  'signed.designs': { en: 'Designs', ar: 'التصاميم' },
  'signed.orders': { en: 'Orders', ar: 'الطلبات' },
  'signed.favorites': { en: 'Favorites', ar: 'المفضلة' },
  'signed.notifications': { en: 'unread', ar: 'غير مقروء' },
  'signed.recentOrders': { en: 'Recent orders', ar: 'الطلبات الأخيرة' },
  'signed.recentOrdersSub': { en: 'Track, reorder or download an invoice.', ar: 'تتبّع أو أعد الطلب أو نزّل الفاتورة.' },
  'signed.trending': { en: 'Trending on Jwalek', ar: 'الأكثر رواجًا في جواليك' },
  'signed.trendingSub': { en: 'Top-rated products & designs right now.', ar: 'أعلى المنتجات والتصاميم تقييمًا الآن.' },
  'signed.freshCommunity': { en: 'Fresh from the community', ar: 'جديد من المجتمع' },
  'signed.freshCommunitySub': { en: 'Real designs, published by real makers.', ar: 'تصاميم حقيقية نشرها مصمّمون حقيقيّون.' },
  'signed.shopByCategory': { en: 'Shop by category', ar: 'تسوّق حسب الفئة' },
  'signed.shopByCategorySub': { en: 'Three product lines, unlimited possibilities.', ar: 'ثلاث فئات من المنتجات، إمكانيات لا حدود لها.' },
  'signed.seeAll': { en: 'See all', ar: 'عرض الكل' },
  'signed.heroCtaNewUser': { en: 'Ready to create your very first piece? Start with a template, jump into the AI generator, or shop what everyone else is loving.', ar: 'جاهز لصنع أول قطعة لك؟ ابدأ بقالب جاهز، أو جرّب مولّد الذكاء الاصطناعي، أو تسوّق ما يحبّه الآخرون.' },
  'signed.heroCtaReturning': { en: "Pick up where you left off — a fresh design, a reorder in one tap, or a jump into what's trending right now.", ar: 'أكمل من حيث توقّفت — صمّم جديدًا، أعد طلبًا بضغطة، أو جرّب الأكثر رواجًا الآن.' },
  'signed.badgePremium': { en: 'Premium member', ar: 'عضو بريميوم' },
  'signed.badgeSignedIn': { en: 'Signed in', ar: 'مسجّل الدخول' },
  'signed.pts': { en: 'pts', ar: 'نقطة' },
  'signed.nextRewardAt': { en: 'Next reward at {n} pts', ar: 'المكافأة التالية عند {n} نقطة' },
  'signed.ptsToGo': { en: '{n} pts to go', ar: 'يتبقّى {n} نقطة' },
  'signed.designSomething': { en: 'Design Something', ar: 'صمّم شيئًا' },
  'signed.tryAiGenerator': { en: 'Try AI Generator', ar: 'جرّب مولّد الذكاء الاصطناعي' },
  'signed.trendingEmpty': { en: 'Ratings are just warming up. Be the first to rate a design.', ar: 'التقييمات في بدايتها. كن أول من يقيّم تصميمًا.' },
  'signed.exploreDesigns': { en: 'Explore designs', ar: 'استكشف التصاميم' },
  'signed.communityEmpty': { en: 'The community feed is quiet today. Publish your first design and start the conversation.', ar: 'المجتمع هادئ اليوم. انشر أول تصميم لك وابدأ الحديث.' },
  'signed.goToMyDesigns': { en: 'Go to my designs', ar: 'اذهب إلى تصاميمي' },
  'signed.explore': { en: 'Explore', ar: 'استكشف' },
  'signed.premiumBadgeUnlocked': { en: 'Premium perks unlocked', ar: 'مزايا البريميوم مُفعّلة' },
  'signed.earnMore': { en: 'You could be earning more', ar: 'يمكنك كسب المزيد' },
  'signed.thanksPremium': { en: 'Thanks for being Premium — your next order ships priority.', ar: 'شكرًا لكونك عضو بريميوم — طلبك القادم يُشحن بأولوية.' },
  'signed.pointsCountingTitle': { en: '{n} points and counting.', ar: '{n} نقطة والعدّاد يزيد.' },
  'signed.premiumSub': { en: 'Redeem your points for discounts, exclusive templates, or gift them to a friend.', ar: 'استبدل نقاطك بخصومات أو قوالب حصرية أو أهدها لصديق.' },
  'signed.earnSub': { en: 'Every order earns loyalty points. Redeem for discounts, unlock exclusive templates, or upgrade to Premium for priority production.', ar: 'كل طلب يمنحك نقاط ولاء. استبدلها بخصومات أو قوالب حصرية أو انضم إلى بريميوم لإنتاج بأولوية.' },
  'signed.manageRewards': { en: 'Manage rewards', ar: 'إدارة المكافآت' },
  'signed.viewRewards': { en: 'View rewards', ar: 'اعرض المكافآت' },
  'signed.goPremium': { en: 'Go Premium', ar: 'انضمّ إلى بريميوم' },
  'signed.designBadge': { en: 'Design', ar: 'تصميم' },
  'signed.productBadge': { en: 'Product', ar: 'منتج' },
  'signed.ratings': { en: 'ratings', ar: 'تقييمًا' },

  // --- Common actions ---
  'common.back': { en: 'Back', ar: 'رجوع' },
  'common.save': { en: 'Save', ar: 'حفظ' },
  'common.cancel': { en: 'Cancel', ar: 'إلغاء' },
  'common.loading': { en: 'Loading...', ar: 'جارٍ التحميل...' },
  'common.viewAll': { en: 'View all', ar: 'عرض الكل' },
  'common.delete': { en: 'Delete', ar: 'حذف' },
  'common.close': { en: 'Close', ar: 'إغلاق' },
  'common.confirm': { en: 'Confirm', ar: 'تأكيد' },
  'common.yes': { en: 'Yes', ar: 'نعم' },
  'common.no': { en: 'No', ar: 'لا' },
  'common.edit': { en: 'Edit', ar: 'تعديل' },
  'common.search': { en: 'Search', ar: 'بحث' },
  'common.filter': { en: 'Filter', ar: 'تصفية' },
  'common.reset': { en: 'Reset', ar: 'إعادة تعيين' },
  'common.error': { en: 'Something went wrong', ar: 'حدث خطأ ما' },
  'common.retry': { en: 'Retry', ar: 'أعد المحاولة' },
  'common.copied': { en: 'Copied to clipboard', ar: 'نُسخ إلى الحافظة' },
  'common.required': { en: 'This field is required', ar: 'هذا الحقل مطلوب' },
  'common.optional': { en: 'Optional', ar: 'اختياري' },
  'common.enabled': { en: 'Enabled', ar: 'مُفعّل' },
  'common.disabled': { en: 'Disabled', ar: 'غير مُفعّل' },
  'common.on': { en: 'On', ar: 'مُشغّل' },
  'common.off': { en: 'Off', ar: 'مُوقّف' },

  // --- Store closure banner + guardrails ---
  'closure.tag': { en: 'Store paused:', ar: 'المتجر متوقف مؤقتًا:' },
  'closure.default': { en: "We're temporarily paused for new orders. Please check back soon.", ar: 'متجرنا متوقّف مؤقتًا عن استقبال الطلبات. عُد لاحقًا.' },
  'closure.cannotAdd': { en: "We're paused for new orders — you can browse but can't add to cart right now.", ar: 'المتجر متوقف مؤقتًا — يمكنك التصفّح ولكن لا يمكنك الإضافة إلى السلة حاليًا.' },
  'closure.cannotCheckout': { en: 'Checkout is paused while the store is closed.', ar: 'إتمام الشراء متوقف بينما المتجر مغلق.' },
  'closure.addToCartLabel': { en: 'Orders paused', ar: 'الطلبات متوقفة' },

  // --- Admin toolbar (view-as-customer + labels) ---
  'admin.viewAsCustomer': { en: 'View site as customer', ar: 'اعرض الموقع كعميل' },
  'admin.viewAsAdmin': { en: 'Back to admin view', ar: 'العودة إلى واجهة الإدارة' },
  'admin.returnToAdmin': { en: 'Return to admin', ar: 'العودة إلى الإدارة' },
  'admin.customerModeToast': { en: "You're now browsing as a customer.", ar: 'تتصفّح الآن بصفة عميل.' },
  'admin.adminModeToast': { en: 'Back in admin view.', ar: 'عدت إلى واجهة الإدارة.' },

  // --- Footer ---
  'footer.tagline': { en: 'Design it your way, we print it perfectly. Custom-printed phone cases, stickers and labels shipped fast.', ar: 'صمّم بأسلوبك، ونحن نطبعه بإتقان. أغطية جوّال وملصقات ولاصقات مخصصة تُشحن بسرعة.' },
  'footer.explore': { en: 'Explore', ar: 'استكشف' },
  'footer.company': { en: 'Company', ar: 'الشركة' },
  'footer.support': { en: 'Support', ar: 'الدعم' },
  'footer.rights': { en: 'All rights reserved.', ar: 'جميع الحقوق محفوظة.' },
  'footer.address': { en: 'Riyadh, Kingdom of Saudi Arabia', ar: 'الرياض، المملكة العربية السعودية' },
  'footer.madeWith': { en: 'Made with ❤️ in Riyadh', ar: 'صُنع بحبّ ❤️ في الرياض' },
  'footer.dmca': { en: 'DMCA', ar: 'حقوق الطبع' },

  // --- Bookmark flyer ---
  'bookmark.title': { en: 'Save Jwalek for later', ar: 'احفظ جواليك لاحقًا' },
  'bookmark.body': { en: 'Bookmark us so your designs, orders, and community feed are one tap away.', ar: 'أضف الموقع إلى المفضلة ليكون تصميمك وطلباتك ومجتمعك على بُعد نقرة واحدة.' },
  'bookmark.gotIt': { en: 'Got it', ar: 'حسنًا' },
  'bookmark.notNow': { en: 'Not now', ar: 'ليس الآن' },
  'bookmark.toBookmark': { en: 'to bookmark', ar: 'للحفظ في المفضلة' },

  // --- Mobile bottom nav ---
  'mobileNav.home': { en: 'Home', ar: 'الرئيسية' },
  'mobileNav.shop': { en: 'Shop', ar: 'المتجر' },
  'mobileNav.designs': { en: 'Designs', ar: 'التصاميم' },
  'mobileNav.cart': { en: 'Cart', ar: 'السلة' },
  'mobileNav.account': { en: 'Account', ar: 'الحساب' },

  // --- Design Editor ---
  'editor.save': { en: 'Save', ar: 'حفظ' },
  'editor.saving': { en: 'Saving...', ar: 'جارٍ الحفظ...' },
  'editor.saveDesign': { en: 'Save design', ar: 'احفظ التصميم' },
  'editor.addToCart': { en: 'Add to Cart', ar: 'أضف إلى السلة' },

  // --- Product type labels (customer-facing type badges) ---
  'productType.phone_case': { en: 'Phone Case', ar: 'غطاء جوّال' },
  'productType.sticker': { en: 'Sticker', ar: 'ملصق' },
  'productType.label': { en: 'Label', ar: 'لاصقة' },

  // --- Design category labels ---
  'designCategory.phone_case': { en: 'Phone Case', ar: 'أغطية الجوال' },
  'designCategory.sticker': { en: 'Sticker', ar: 'ملصقات' },
  'designCategory.label': { en: 'Label', ar: 'لاصقات' },
};

// iPhone / size / label model chip labels. These come from admin catalog_options
// (kind='model') and are stored in English; we translate on the fly for
// customer-facing surfaces. Admin-created product NAMES are intentionally left
// untranslated (they are user data).
const MODEL_TRANSLATIONS_AR = {
  // iPhone models
  'iPhone 14': 'آيفون 14',
  'iPhone 14 Plus': 'آيفون 14 بلس',
  'iPhone 14 Pro': 'آيفون 14 برو',
  'iPhone 14 Pro Max': 'آيفون 14 برو ماكس',
  'iPhone 15': 'آيفون 15',
  'iPhone 15 Plus': 'آيفون 15 بلس',
  'iPhone 15 Pro': 'آيفون 15 برو',
  'iPhone 15 Pro Max': 'آيفون 15 برو ماكس',
  'iPhone 16': 'آيفون 16',
  'iPhone 16 Plus': 'آيفون 16 بلس',
  'iPhone 16 Pro': 'آيفون 16 برو',
  'iPhone 16 Pro Max': 'آيفون 16 برو ماكس',
  // Sticker sizes
  '2 inch': '٢ إنش',
  '3 inch': '٣ إنش',
  '4 inch': '٤ إنش',
  '5 inch': '٥ إنش',
  '3 inch custom shape': '٣ إنش شكل مخصص',
  '4 inch custom shape': '٤ إنش شكل مخصص',
  '20 pack': 'عبوة ٢٠',
  '50 pack': 'عبوة ٥٠',
  '100 pack': 'عبوة ١٠٠',
  // Label shapes / sizes
  'Round 1"': 'دائري ١ إنش',
  'Round 2"': 'دائري ٢ إنش',
  'Round 3"': 'دائري ٣ إنش',
  'Rectangle 2x3"': 'مستطيل ٢×٣ إنش',
  'Rectangle 3x2"': 'مستطيل ٣×٢ إنش',
  'Square 2"': 'مربع ٢ إنش',
  'Square 2.5"': 'مربع ٢٫٥ إنش',
  'Oval 2x3"': 'بيضاوي ٢×٣ إنش',
  // Finishes (variants)
  'Clear': 'شفاف',
  'Matte Black': 'أسود مطفي',
  'Frosted': 'مثلج',
  'Glossy': 'لامع',
  'Matte': 'مطفي',
  'Holographic': 'هولوغرام',
  'Kraft': 'كرافت',
  'Metallic': 'معدني',
  'Waterproof': 'مقاوم للماء',
  'Removable': 'قابل للإزالة',
};

/** Translate an iPhone model / sticker size / label shape / finish value. */
export function translateModel(lang, value) {
  if (!value || lang !== 'ar') return value;
  if (MODEL_TRANSLATIONS_AR[value]) return MODEL_TRANSLATIONS_AR[value];
  // Handle composite variant strings like "iPhone 15 Pro / Clear"
  if (typeof value === 'string' && value.includes(' / ')) {
    return value.split(' / ').map((p) => MODEL_TRANSLATIONS_AR[p.trim()] || p.trim()).join(' / ');
  }
  return value;
}

export function translate(lang, key, fallback) {
  const row = dict[key];
  if (!row) return fallback ?? key;
  return row[lang] || row.en || fallback || key;
}
